import React from 'react';
// import { WelcomeSection, AboutUsSection } from 'components/layout/Home';
import { PageWrapper } from 'components/modules/wrapper';
import { Dessert, Drink, Food, Fruit } from 'components/layout/Home';
import { Link } from 'react-router-dom';
function HomePageView() {
  return (
    <PageWrapper>
      <div className="px-10">
        <div>
          <div className="flex items-center gap-x-10 bg-black mt-10 py-2 px-4 rounded-xl">
            <h2 className="font-semibold text-white text-base">
              Delicious Foods
            </h2>
            <Link to="/Food" className="font-400 text-white text-base">
              View All &gt;
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-7 2xl:grid-cols-7 pb-10">
            <Food />
          </div>
          <div className="flex items-center gap-x-10 bg-black mt-10 py-2 px-4 rounded-xl">
            <h2 className="font-semibold text-white text-base">Tasty Drinks</h2>
            <Link to="/Drink" className="font-400 text-white text-base">
              View All &gt;
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-7 2xl:grid-cols-7 pb-10">
            <Drink />
          </div>
          <div className="flex items-center gap-x-10 bg-black mt-10 py-2 px-4 rounded-xl">
            <h2 className="font-semibold text-white text-base">Fresh Fruits</h2>
            <Link to="/Fruits" className="font-400 text-white text-base">
              View All &gt;
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-7 2xl:grid-cols-7 pb-10">
            <Fruit />
          </div>
          <div className="flex items-center gap-x-10 bg-black mt-10 py-2 px-4 rounded-xl">
            <h2 className="font-semibold text-white text-base">
              Yummy Desserts
            </h2>
            <Link to="/Dessert" className="font-400 text-white text-base">
              View All &gt;
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-7 2xl:grid-cols-7 pb-10">
            <Dessert />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default HomePageView;
